import { Component, OnInit } from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-cfc-readonly-text-editor',
  templateUrl: './cfc-readonly-text-editor.component.html',
  styleUrls: ['./cfc-readonly-text-editor.component.less']
})
export class CfcReadonlyTextEditorComponent {

  formGroup: FormGroup;
  disabledExpr: Function;
  key;
  // private value;
  columnName: string;
  private rowId: number;

  agInit(params: any) {
    this.columnName = params.column.colDef.headerName;
    // this.key = params.context.createKey(params.columnApi, params.column);
    this.key = params.column.colId;
    // this.value = params.value;
    this.rowId = params.node.id;

    // const gridFormArray = params?.context.gridFormArray;
    // const rowFromGroup = gridFormArray.at(params.rowIndex);

    // const rowFromGroup = params.context.rowCachedFormGroup;

    const rowFromGroup = params.context.serviceObj.rowCachedFormGroup;
    // const cellFormControl = rowFromGroup.get(this.key);
    this.formGroup = rowFromGroup;

  }

  getValue(): any {
    // return this.value;
    return this.formGroup.get(this.key).value;
  }

  onKeyDown(event: any): void {
    if (event.keyCode === 13 || event.keyCode === 27 || event.keyCode === 37 || event.keyCode === 38
      || event.keyCode === 39 || event.keyCode === 40) {
      event.stopPropagation();
    }
  }

}
